const CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE = 'check-availability';
const SEARCH_SUBMIT_ACTION_TYPE = 'search';

const DEFAULT_SUBMIT_ACTION_TYPE = SEARCH_SUBMIT_ACTION_TYPE;

const SUBMIT_ACTION_TYPES = [
    CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE,
    SEARCH_SUBMIT_ACTION_TYPE
];

function hasSubmitActionType(ACTION_TYPE, submit) {
    let {
        options: {
            actionType
        }
    } = submit;

    actionType = `${actionType}`.toLowerCase();

    return actionType === ACTION_TYPE;
}

/* istanbul ignore next */
function hasDefaultSubmitActionType(submit) {
    return hasSubmitActionType(DEFAULT_SUBMIT_ACTION_TYPE, submit);
}

function hasCheckAvailabilitySubmitActionType(submit) {
    return hasSubmitActionType(CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE, submit);
}

/* istanbul ignore next */
function hasSearchSubmitActionType(submit) {
    return hasSubmitActionType(SEARCH_SUBMIT_ACTION_TYPE, submit);
}

export {
    DEFAULT_SUBMIT_ACTION_TYPE,
    CHECK_AVAILABILITY_SUBMIT_ACTION_TYPE,
    SEARCH_SUBMIT_ACTION_TYPE,
    SUBMIT_ACTION_TYPES,
    hasDefaultSubmitActionType,
    hasCheckAvailabilitySubmitActionType,
    hasSearchSubmitActionType
};
